import { Button, TextField } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FeatureForm } from './FeatureForm'

export const TypeForm = ({ specification, index }) => {
    const { register, watch, setValue, getValues } = useFormContext()


    const addNewFeature = () => {
        setValue(`specifications[${index}].features[${specification.features.length}]`, {
            name: "",
            type: "",
            values: []
        })
    }

    const removeType = () => {
        const specifications = getValues('specifications')
        specifications.splice(index, 1)
        setValue('specifications', specifications)
    }

    return (
        <div className="app-form" style={{ border: "1px solid #ccc", padding: "1rem", marginBottom: "1rem"}}>
            <div className="m-b-16" style={{ cursor: 'pointer' }} onClick={() => {
                // toggle open
                const el = document.querySelector(`#type-${index}-content`)
                el.style.display = el.style.display === 'none' ? 'block' : 'none'
            }}>
                <strong>Раздел: {specification.name}</strong>
            </div>
            <div id={`type-${index}-content`} style={{ display: 'none' }} className='app-form'>
                <TextField label="Название раздела" {...register(`specifications[${index}].name`)} fullWidth className="m-b-16" />
                <TextField label="Код" {...register(`specifications[${index}].code`)} fullWidth className="m-b-16" />
                <TextField label="Описание" {...register(`specifications[${index}].description`)} fullWidth className="m-b-16" />
                <section style={{ border: "1px solid #ccc", padding: "1rem", marginBottom: "1rem" }}>
                    <div>
                        <div className='m-b-16'>Свойства: </div>
                        {/* Список добавленных возможностей */}
                        {specification.features.map((feature, featureIndex) => {
                            return <FeatureForm feature={feature} specificationIndex={index} featureIndex={featureIndex} />
                        })}
                    </div>
                    <Button variant="text" className="m-b-16" onClick={addNewFeature}>Добавить возможность</Button>
                </section>
                <div className="m-b-16">
                    <Button variant="text" className="m-b-16" onClick={removeType}>Удалить раздел</Button>
                </div>
            </div>
        </div>
    )
}
